/**
 * @name Store
 * @author Moaaz Ahmed
 * @summary This file will be containing all the configs for redux store.
 * @description This file contains some generic code that is responsible for running redux. Please align with your manager before updating this file.
 * @access private
 *
 * @readonly Please don't make any changes to this file.
 */

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from 'redux/rootReducer';

const store = configureStore({
  reducer: rootReducer,
  // Thunk only (legacy async actions): Toolkit's dev-only immutability/serializability checks stay off.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
  devTools: process.env.REACT_APP_ENV_VAR !== 'production',
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
